export const abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_address',
                type: 'address'
            }
        ],
        name: 'ContractAdded',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_address',
                type: 'address'
            }
        ],
        name: 'ContractRemoved',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_oldAddress',
                type: 'address'
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_newAddress',
                type: 'address'
            }
        ],
        name: 'ContractUpgraded',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address'
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address'
            }
        ],
        name: 'OwnershipTransferred',
        type: 'event'
    },
    {
        constant: true,
        inputs: [],
        name: 'isOwner',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address'
            }
        ],
        name: 'transferOwnership',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'initialize',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'address',
                name: 'sender',
                type: 'address'
            }
        ],
        name: 'initialize',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            },
            {
                internalType: 'address',
                name: '_address',
                type: 'address'
            }
        ],
        name: 'addContract',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            }
        ],
        name: 'removeContract',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            },
            {
                internalType: 'address',
                name: '_newAddress',
                type: 'address'
            }
        ],
        name: 'upgradeContract',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: true,
        inputs: [
            {
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            },
            {
                internalType: 'uint256',
                name: '_version',
                type: 'uint256'
            }
        ],
        name: 'getContract',
        outputs: [
            {
                internalType: 'address',
                name: 'contractAddr',
                type: 'address'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [
            {
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            }
        ],
        name: 'getContract',
        outputs: [
            {
                internalType: 'address',
                name: 'contractAddr',
                type: 'address'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [
            {
                internalType: 'bytes32',
                name: '_name',
                type: 'bytes32'
            }
        ],
        name: 'getContractVersionCount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    }
];
//# sourceMappingURL=abi.js.map